import axios, {AxiosError} from "axios";
import { API_URL } from "../constant";
import { LoginResult } from "../constant";
  
export async function loginUser(username : string, password: string): Promise<LoginResult> {

    try {
        localStorage.clear()
        const formData = new URLSearchParams();
        formData.append("username", username );
        formData.append("password", password);
        
        const response = await axios.post(
          `${API_URL}api/user/login`,
          formData,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
            validateStatus: (status) => {
                return status >= 200 && status < 500;
            },
          }
        );
    
        if (response.status === 200)
        {
            console.log("Login Success:", response.data);
            localStorage.setItem("token", response.data.access_token);
            localStorage.setItem("session", JSON.stringify(response.data));
            return { success: true, ...response.data };
        }
        else if (response.status === 401){
            return { success: false, errorMsg: "Invalid username or password" };
        }
        else{
            return { success: false, errorMsg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: false, errorMsg: `"Server Error:"${error.response.status}, ${error.response.data}` };
        } else if (error.request) {
            return { success: false, errorMsg: "No response received from server" };
        } else {
            return { success: false, errorMsg: `Error:, ${error.message}` };
        }
    }
}